var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 48,
    height: 48,
    fill: "#e61f26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.14,12.94a7.2,7.2,0,0,0,.05-.94,7.2,7.2,0,0,0-.05-.94l2.11-1.65a.5.5,0,0,0,.12-.64l-2-3.46a.5.5,0,0,0-.61-.22l-2.49,1a7.34,7.34,0,0,0-1.63-.94l-.38-2.65a.5.5,0,0,0-.5-.42h-4a.5.5,0,0,0-.5.42l-.38,2.65a7.34,7.34,0,0,0-1.63.94L4.29,5.07a.5.5,0,0,0-.61.22l-2,3.46a.5.5,0,0,0,.12.64L4,11.06a7.2,7.2,0,0,0-.05.94,7.2,7.2,0,0,0,.05.94L1.88,14.59a.5.5,0,0,0-.12.64l2,3.46a.5.5,0,0,0,.61.22l2.49-1a7.34,7.34,0,0,0,1.63.94l.38,2.65a.5.5,0,0,0,.5.42h4a.5.5,0,0,0,.5-.42l.38-2.65a7.34,7.34,0,0,0,1.63-.94l2.49,1a.5.5,0,0,0,.61-.22l2-3.46a.5.5,0,0,0-.12-.64ZM12,15.5A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteSettings);
export default __webpack_public_path__ + "static/media/siteSettings.6701406a5adce65637097f39b9e831f7.svg";
export { ForwardRef as ReactComponent };